<template>
  <div v-show="state" class="randomPoster" style="z-index: 2003;">
    <div class="dialog">
      <div class="dialog_header">
        <button type="button" class="dialog__headerbtn" @click="close">
          <i class="iconfont iconquxiao1"></i>
        </button>
      </div>
      <img :src="url" alt />
      <div class="dialog_footer"><span @click="init">换一张</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RandomPoster",
  props: ["state"],
  data() {
    return {
      arr: [
        "../../static/posters/0219_1.jpg",
        "../../static/posters/0219_2.jpg",
        "../../static/posters/0219_3.jpg",
        "../../static/posters/0219_4.jpg",
        "../../static/posters/0219_5.jpg",
        "../../static/posters/0219_6.jpg",
        "../../static/posters/0219_7.jpg",
        "../../static/posters/0219_8.png",
        "../../static/posters/0219_9.jpg",
        "../../static/posters/0219_10.jpg",
        "../../static/posters/0219_11.jpg",
        "../../static/posters/0219_12.jpg"
      ],
      url: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.url = this.arr[Math.floor(Math.random() * 12)];
    },
    close() {
      this.$emit("transfer", this.state);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.randomPoster {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  background: rgba(0, 0, 0, 0.5);
  .dialog {
    position: relative;
    margin: 0 auto 50px;
    margin-top: 10vh;
    box-sizing: border-box;
    width: 80%;
    border-radius: 6px;
    .dialog_header {
      position: absolute;
      right: 0;
      padding: 8px 8px 0;
      .dialog__headerbtn {
        width: 26px;
        height: 26px;
        padding: 0;
        background: #fff;
        border-radius: 50%;
        border: none;
        outline: none;
        cursor: pointer;
        i {
          font-size: 10px;
        }
      }
    }
    img {
      width: 100%;
      height: 100%;
    }
    .dialog_footer {
      margin-top: 10px;
      text-align: center;
      span {
          color:#fff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RandomPoster.vue